/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';

import withTranslate from '../../hoc/with-translate';
import { getIsMobile, isExperimentEnabled } from '../../state/site/selectors';
import { Experiments } from '../../constants/experiments';
import styles from './more-button.scss';
import { MoreIcon } from '../icons/more-icon';
import { SIDE_POSITION as POSITION } from '../../constants/positioning';
import Tooltip from '../tooltip';
import Popover from '../popover';

interface Props {
  t: TranslationFunction;
  isMobile: boolean;
  isRtlLocale: boolean;
  className?: string;
  dynamicPositioning?: boolean;
  iconContainerClass?: string;
  position?: string;
  icon?: React.ReactNode;
  isPopoverOpen?: boolean;
  ariaLabel?: string;
  menuId?: string;
  shouldUsePopoverDynamicPositioning: boolean;
}

export class MoreButton extends React.Component<Props> {
  public static defaultProps: Partial<Props> = {
    icon: <MoreIcon className="ma-more-button" />,
  };

  state = {
    isExpanded: this.props.isPopoverOpen,
    isFocused: false,
  };

  setExpanded = (isExpanded: boolean) => {
    this.setState({ isExpanded });
  };

  setFocused = (isFocused: boolean) => {
    this.setState({ isFocused });
  };

  renderIcon() {
    const { icon, iconContainerClass } = this.props;

    return (
      <div data-hook="more-button">
        <div className={classNames(styles.icon, iconContainerClass)}>
          {icon}
        </div>
      </div>
    );
  }

  renderIconWithTooltip = () => (
    <Tooltip
      text={this.props.t('more-button.tooltip')}
      placement={this.props.isRtlLocale ? POSITION.RIGHT : POSITION.LEFT}
      isTargetFocused={this.state.isFocused}
    >
      {this.renderIcon()}
    </Tooltip>
  );

  render() {
    const {
      className,
      isMobile,
      dynamicPositioning,
      children,
      position,
      shouldUsePopoverDynamicPositioning,
      ariaLabel,
      menuId,
    } = this.props;
    return (
      <Popover
        className={classNames(className, styles.container)}
        dynamicPositioning={shouldUsePopoverDynamicPositioning ? true : dynamicPositioning}
        content={children}
        position={position}
        onOpen={() => this.setExpanded(true)}
        onClose={() => this.setExpanded(false)}
        shouldUsePopoverDynamicPositioning={shouldUsePopoverDynamicPositioning}
        onFocus={() => this.setFocused(true)}
        onBlur={() => this.setFocused(false)}
        ariaLabel={ariaLabel}
        menuId={menuId}
      >
        <div className={styles.more}>
          {!isMobile && !this.state.isExpanded ? this.renderIconWithTooltip() : this.renderIcon()}
        </div>
      </Popover>
    );
  }
}

export default connect<
  { isMobile: boolean },
  {},
  {
    dynamicPositioning?: boolean;
    iconContainerClass?: string;
    position?: string;
    isRtlLocale?: boolean;
    className?: string;
    isPopoverOpen?: boolean;
    ariaLabel?: string;
    menuId?: string;
  }
>((state: any) => ({
  isMobile: getIsMobile(state),
  shouldUsePopoverDynamicPositioning: isExperimentEnabled(state, Experiments.USE_POPOVER_DYNAMIC_POSITIONING),
}))(withTranslate(MoreButton));
